import _ from 'lodash';

/**
 * Formate un numéro de téléphone français pour l'affichage :
 * - "0123456789" -> "01 23 45 67 89"
 * - "+33123456789" -> "+33 1 23 45 67 89"
 *
 * Si le numéro reçu ne correspond à aucun de ces formats classiques
 * (numéro incomplet, court, étranger, extension, etc.), il est affiché
 * tel quel plutôt que d'être masqué ou tronqué.
 */
const formatPhoneNumber = (phoneNumber?: string | number | null): string => {
  if (_.isNil(phoneNumber) || phoneNumber === '') return '';

  const raw = String(phoneNumber).trim();
  if (!raw) return '';

  if (raw.startsWith('+')) {
    const digits = raw.slice(1).replace(/\D/g, '');

    // Format classique attendu : indicatif à 2 chiffres + 9 chiffres (FR)
    if (digits.length === 11) {
      const indicatif = digits.slice(0, 2);
      const nationalDigits = digits.slice(2).split('');
      const firstDigit = _.head(nationalDigits);
      const remainingDigits = _.tail(nationalDigits);
      const chunks = _.chunk(remainingDigits, 2);
      const formatted = _.join(_.map(chunks, (chunk) => _.join(chunk, '')), ' ');

      return `+${indicatif} ${firstDigit} ${formatted}`;
    }

    return raw;
  }

  const digits = raw.replace(/\D/g, '');

  // Format classique attendu : 10 chiffres (FR)
  if (digits.length === 10) {
    const chunks = _.chunk(digits.split(''), 2);
    return _.join(_.map(chunks, (chunk) => _.join(chunk, '')), ' ');
  }

  return raw;
};

export default formatPhoneNumber;
